import React from 'react';
import { Clock } from 'lucide-react';

export const RecentEmptyState: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center p-6 text-center h-48 text-muted-foreground">
      <div className="h-10 w-10 rounded-full bg-muted/50 flex items-center justify-center mb-3">
        <Clock className="h-5 w-5 text-muted-foreground/70" />
      </div>
      <p className="text-sm font-medium text-foreground">No recent pages</p>
      <p className="text-xs text-muted-foreground mt-1">
        Pages you visit and actions you perform will appear here.
      </p>
    </div>
  );
};
